var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    viewBox: "0 0 51 68",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.5 4c-10.767 0-19.5 8.778-19.5 19.6 0 14.7 19.5 36.4 19.5 36.4s19.5-21.7 19.5-36.4c0-10.822-8.733-19.6-19.5-19.6z",
    fill: "#00729f",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.856 20.28h9.077c.552 0 1 .448 1 1v7.931c0 .226-.076.445-.217.622l-4.539 5.704c-.344.432-.973.503-1.405.159-.059-.047-.113-.1-.16-.159l-4.538-5.704c-.141-.177-.218-.396-.218-.622v-7.931c0-.552.448-1 1-1z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.856 11h9.077c.552 0 1 .448 1 1v3.8c0 .552-.448 1-1 1h-9.077c-.552 0-1-.448-1-1v-3.8c0-.552.448-1 1-1z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.779 39.42-2.515-9.233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.472 30.235-2.516 9.232"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.6bcbfa999cbcd017e052cdbe3987075b.svg";
export { ForwardRef as ReactComponent };